import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AuthUser } from '@classes/auth/auth-user';
import { Camera, latlngConvert } from '@classes/camera/camera';
import { User } from '@classes/user/user';
import { AddUser } from '@classes/user/userAdd';
import { CameraWaste } from '@classes/waste-camera/waste-camera';
import { AuthService } from '@services/auth/auth.service';
import { CamerasService } from '@services/cameras/cameras.service';
import { CameraWasteService } from '@services/cameraWaste/CameraWasteService';

@Component({
  selector: 'app-smartwaste-camera',
  templateUrl: './smartwaste-camera.component.html',
  styleUrls: ['./smartwaste-camera.component.scss']
})
export class SmartwasteCameraComponent implements OnInit {
  user: AuthUser;
  cameras: Camera[];
  cameraWaste: CameraWaste[];
  lat = 50.597551;
  lng = 3.403683;
  zoom = 7.8;
  displayedColumns: string[] = ['camera', 'batterie', 'infraction'];
  dataSource: MatTableDataSource<Camera>;


  constructor(
    // private CameraWasteService: CameraWasteService,
    private authService: AuthService,
    private cameraService: CamerasService
  ) { }

  ngOnInit(): void {
    this.getUserCurrent();
    this.getCameraWaste();

  }

  getUserCurrent() {
    this.user = this.authService.getUser();


  }
  updateMarker(el): void {

    this.lat = el.location.lat;
    this.lng = el.location.lng;
    this.zoom = 15
  }
  getCamerasByClient(client: string): Camera[] {

    const cameraClient = this.cameras.filter(cameras => cameras.client.name === this.user.client.name);

    return cameraClient

  }

  private getCameraWaste(): void {

    this.cameraService.getCameras().subscribe(res => {

      res.forEach(el => {
        const latLngSplit = (el.location as string).split(',');
        el.location = new latlngConvert(+latLngSplit[0], +latLngSplit[1])

      });

      // this.cameraWaste = this.CameraWasteService.waste;
      this.dataSource = new MatTableDataSource<Camera>(this.cameras);



    });
  }
}
